import isTrackingEnabled from './utils/isTrackingEnabled';
import trackView from './utils/trackView';
import setPageTrackingData from './utils/setPageTrackingData';
import getPageTrackingData from './utils/getPageTrackingData';
import trackLink from './utils/trackLink';
import configurationService from '../../services/configurationService';
import axios from 'axios';

const trackEventInDev = (type: string, eventName: string, attributes: any) => {
  if (configurationService.isLocalDev()) {
    const url = configurationService.getRelativeUrl('/events');
    // eslint-disable-next-line no-void
    void axios.post(url, { type, eventName, attributes });
  }

  /* eslint-disable-next-line no-console */
  console.log(
    `trackingEnabled=false => track event '${type}:${eventName}' with data`,
    attributes,
  );
};

export const trackPageLoad = (
  eventName: string,
  pageData: any,
  extraData: any,
) => {
  const attributes = { ...pageData, ...extraData };
  setPageTrackingData(pageData);

  if (isTrackingEnabled()) {
    trackView(eventName, attributes);
  } else {
    trackEventInDev('trackView', eventName, attributes);
  }
};

// TODO_TYPES should attributes be typed?
export const trackEvent = (eventName: string, attributes: any) => {
  const currentPageTrackingData = getPageTrackingData();

  const data = {
    ...currentPageTrackingData,
    ...attributes,
  };

  if (isTrackingEnabled()) {
    trackLink(eventName, data);
  } else {
    trackEventInDev('trackLink', eventName, data);
  }
};
export const trackEventView = (eventName: string, attributes: any) => {
  const currentPageTrackingData = getPageTrackingData();

  const data = {
    ...currentPageTrackingData,
    ...attributes,
  };

  if (isTrackingEnabled()) {
    trackView(eventName, data);
  } else {
    trackEventInDev('trackView', eventName, data);
  }
};
